import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ResourceModel } from 'projects/core/src/lib/models/resource.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { FileHandlingComponent } from 'projects/admin/src/app/partials/data/file-handling/file-handling.component';
import FileSaver from 'file-saver';

@Component({
  selector: 'app-reporttemplates-list',
  templateUrl: './reporttemplates-list.component.html',
  styleUrls: ['./reporttemplates-list.component.scss']
})
export class ReporttemplatesListComponent extends BaseList implements OnInit {

  @ViewChild('filehandler') filehandler: FileHandlingComponent;

  public inEdit = false;
  public uploadOpened = false; // @deprecated
  public submitting = false;
  public editReporttemplate: ResourceModel = null;
  public form: UntypedFormGroup = this.fb.group({
    filename: new UntypedFormControl('', [Validators.required]),
  });

  public reporttemplates: Array<ResourceModel> = [];
  public testVisible = false;
  public testValueLoading = false;
  public testResource: ResourceModel | null = null;
  public testJson: string | null = null;
  public testBusy = false;

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    private fb: UntypedFormBuilder,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('files', { type: 'aireport.template'}).subscribe({
      next: (reporttemplates: any) => {
        this.reporttemplates = [];
        reporttemplates.data.forEach((ac: any) => {
          this.reporttemplates.push(new ResourceModel().deserialize(ac));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  onNew(): void {
    this.filehandler.openFileUpload();
  }

  onStartDelete(resource: ResourceModel): void {
    this.filehandler.onDeleteFile(this.reporttemplates, resource);
  }

  onDelete(resources: Array<ResourceModel>): void {
    this.reporttemplates = resources;
  }

  onDownload(resource: ResourceModel): void {
    this.filehandler.downloadFile(resource);
  }

  onFilesUpload(files: Array<ResourceModel>): void {
    files.forEach((file: ResourceModel) => {
      this.reporttemplates.push(file);
    });
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        filename: this.addExtension(this.form.value.filename),
        candidate: this.form.value.candidate,
        observer: this.form.value.observer,
      };
      this.api.saveModel('files', this.editReporttemplate.id, payload).subscribe({
        next: (result: any) => {
          this.editReporttemplate.public_name = result.data.public_name;
          this.editReporttemplate.permissions = result.data.permissions;
          this.ui.toastSuccess(this.transloco.translate('ac_files.filename_changed', { value: this.editReporttemplate.public_name }), this.transloco.translate('common.changed'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onOpenTestWindow(resource: ResourceModel): void {
    if (this.auth.hasRight('admin.reporttemplate.test')) {
      this.testResource = resource;
      this.testVisible = true;
      this.testValueLoading = true;
      this.api.getAITemplateTestValue().subscribe({
        next: (result: any) => {
          this.testJson = result.data?.test_value || null;
        },
        error: (error: any) => {
        }
      }).add(() => {
        this.testValueLoading = false;
      });
    }
  }

  onRunTest(): void {
    if (this.auth.hasRight('admin.reporttemplate.test')) {
      this.testBusy = true;
      this.api.runAITemplateTest(this.testResource.id, this.testJson).subscribe({
        next: (result: any) => {
          const blob = new Blob([result]);
          FileSaver.saveAs(blob, this.testResource.public_name);
        },
        error: (error: any) => {
          this.ui.toastError(this.transloco.translate(error.message), this.transloco.translate('common.error'));
        }
      }).add(() => {
        this.testBusy = false;
        this.testVisible = false;
      });
    }
  }

  onCancel(): void {
    this.editReporttemplate = null;
    // this.stopEdit();
  }

  startEdit(): void {
    this.form.patchValue({
      filename: this.deleteExtension(this.editReporttemplate.public_name),
    });
    this.inEdit = true;
  }

  stopEdit(): void {
    this.form.reset();
    this.inEdit = false;
  }

  private deleteExtension(filename: string): string {
    return filename.replace(/\..*$/gm, '');
  }

  private addExtension(filename: string): string {
    return filename + this.editReporttemplate.public_name.match(/\..*$/gm)[0];
  }

}
